<template>
  <v-dialog persistent max-width="710" :fullscreen="isMobile" v-model="dialog">
    <v-form class="fill-height message-form-container" ref="messageForm">
      <v-card class="fill-height" tile>
        <v-card-title>
          <span class="title">Send Us Feedback</span>
          <v-spacer></v-spacer>
          <v-icon
            class="ml-3"
            @click.native="closeModal()"
          >
            close
          </v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert dense type="error" outlined :value="true" v-if="error">{{ error }}</v-alert>
          <v-flex xs12 class="px-2" id="messageBlock">
            <v-layout align-end class="mb-2">
              <v-flex xs12 class="d-flex body_variables">
                <div class="caption grey--text" :class="messageValidate ? 'error--text' : ''">Message*</div>
                <v-spacer/>
              </v-flex>
            </v-layout>
              <div class="tiny_editor">
                <div :class="disabledEditor ? 'disabledEditor' : ''"></div>
                <editor
                    v-if="!isBusy"
                    :api-key="TINY_MCE_API_KEY"
                    :plugins="tinyPlugins"
                    :toolbar="tinyToolbars"
                    :init="tinyInit"
                    v-model="message"
                    :disabled="disabledEditor"
                    @keyup="inputEmail"
                />
              </div>
          </v-flex>
        </v-card-text>
        <v-divider class="mt-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="secondary"
            @click.native="closeModal()"
          >
            Cancel
          </v-btn>
          <v-btn
              color="primary"
              :loading="isBusy"
              @click.native="onSend"
              :disabled="this.message.length === 0"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import TinyConfig from "@/mixins/tiny-mce-config"
import ShorterUrl from "@/mixins/shorterUrl";
import FeedbackService from "@/services/FeedbackService";

export default {
  name: 'SendFeedbackModal',
  mixins: [ TinyConfig, ShorterUrl, FeedbackService],
  components: {
    'editor': Editor, // Do not change, this is a requirement of tinyMCE
  },
  data() {
    return {
      dialog: false,
      error: '',
      message: '',
      isBusy: false,
      messageValidate: ''
    }
  },
  methods: {
    openModal() {
      this.isBusy = true
      this.dialog = true
      setTimeout(() => {
        this.isBusy = false
      }, 500)
    },
    closeModal() {
      this.message = ''
      this.dialog = false
    },
    async inputEmail() {
      this.$nextTick(async () => {
        this.messageValidate = ''
        const newContent = await this.parsUrl(this.message)

        if (newContent !== this.message) {
          this.message = newContent
          this.disabledEditor = false
          document.activeElement.blur()
        }
      })
    },
    async onSend() {
      this.isBusy = true
      let params = {
        message: this.message,
      }
      this.sendFeedbackMail(params).then(() => {
        this.closeModal()
        this.message = ''
        this.error = ''
        this.isBusy = false
        this.onCallToastr('success', 'Message sent', 'Success!')
      }, (err) => {
        this.isBusy = false
        this.handleError(err)
      })
    }
  }
}
</script>

<style lang="scss">
.message-form-container {
  .tox.tox-tinymce {
    height: 280px !important;
    @media (max-width: 767px){
      height: 230px !important;
    }
  }
}
</style>
